import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Flex, Divider, Popup } from 'nallian-shared-ui/lib/components';

const PopupAndCopy = ({ value, position }) => {
  const { t } = useTranslation();

  if (!value) return '-';

  return (
    <Popup position={position || 'top left'} on="hover" hoverable trigger={<span>{value}</span>}>
      <Flex fluid direction="column">
        <Flex>{value}</Flex>
        <Divider />
        <CopyToClipboard text={value}>
          <Button btnprimary icon="copy" content={t('copyToClipboard')} />
        </CopyToClipboard>
      </Flex>
    </Popup>
  );
};

PopupAndCopy.propTypes = { value: PropTypes.string, position: PropTypes.string };
PopupAndCopy.defaultProps = { value: undefined, position: undefined };

export default PopupAndCopy;
